/**
 * Maximum number of characters the AI search input accepts.
 *
 * Mirrors the limit already enforced by the AI search API, so anything beyond
 * this is cut off in the UI rather than sent and rejected.
 */
export const AI_SEARCH_MAX_QUERY_LENGTH = 100
